import { render, staticRenderFns } from "./SubmitList.vue?vue&type=template&id=df4f5104&scoped=true&"
import script from "./SubmitList.vue?vue&type=script&lang=ts&"
export * from "./SubmitList.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitList.vue?vue&type=style&index=0&id=df4f5104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4f5104",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow,VSpacer})
